import { Fragment } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import { SbSharedRefineMenuInputRangeCurrency } from '../../SbSharedRefineMenu/SbSharedRefineMenuInputRange/SbSharedRefineMenuInputRangeCurrency';
import { SbSharedRefineMenuPriceRanges } from '../../SbSharedRefineMenu/SbSharedRefineMenuPriceRanges/SbSharedRefineMenuPriceRanges';
import { SbSharedRefineMenuSaleInput } from '../../SbSharedRefineMenu/SbSharedRefineMenuSaleInput/SbSharedRefineMenuSaleInput';

export const SbMobileRefineMenuFilterPriceComponent = props => (
    <Fragment>
        <SbSharedRefineMenuPriceRanges {...props} />
        <SbSharedRefineMenuInputRangeCurrency {...props} applyOnBlur />
        <SbSharedRefineMenuSaleInput {...props} />
    </Fragment>
);

export const SbMobileRefineMenuFilterPrice = createFragmentContainer(
    SbMobileRefineMenuFilterPriceComponent,
    {
        user: graphql`
            fragment SbMobileRefineMenuFilterPrice_user on User {
                ...SbSharedRefineMenuPriceRanges_user
            }
        `,
        itemSearch: graphql`
            fragment SbMobileRefineMenuFilterPrice_itemSearch on ItemSearchQueryConnection {
                ...SbSharedRefineMenuInputRangeCurrency_itemSearch
                ...SbSharedRefineMenuPriceRanges_itemSearch
                ...SbSharedRefineMenuSaleInput_itemSearch
            }
        `,
    }
);
